// 前端字典映射

export function channelText(v) {
  const map = {
    online: '线上',
    offline: '线下',
    agency: '旅行社'
  }
  return map[v] || v || ''
}
